import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { deleteCaseRevisionQuery, fetchCaseRevisionsTableQuery } from 'app/edozvola/cases/case-revision/service/case-revision.queries';
import { CaseRevisionViewModel } from 'app/edozvola/cases/case-revision/model/case-revision.model';
import { getCaseRevisionFile } from 'app/edozvola/cases/case-revision/service/case-revision.service';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import error = toast.error;
import { openFileInNewWindow } from 'app/shared/util/navigation-util';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { TABLE_QUERY_KEYS } from 'app/config/constants';

const CaseRevisionTable = ({ setMainProjectRevision, setReadOnly, editRevisionDisabled }) => {
  const { id } = useParams<{ id: string }>();
  const { sidebarItemPair } = getCaseContext();

  const [idRevisionToDelete, setIdRevisionToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.CASE_REVISION_TABLE);

  const { mutate: deleteMainProjectRevisionMutation, isPending: deletingInProgress } = deleteCaseRevisionQuery();

  const openMainProjectRevisionForm = (idMainProjectRevision: number, readOnly: boolean) => {
    setMainProjectRevision(idMainProjectRevision);
    setReadOnly(readOnly);
  };

  const openDeleteDialog = idToDelete => {
    setIdRevisionToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeMainProjectRevision = () => {
    setDeleteModalShown(false);
    deleteMainProjectRevisionMutation(idRevisionToDelete);
  };

  const renderTableRow = (value: CaseRevisionViewModel, revisionIndex: number, totalItems: number) => {
    return (
      <tr key={revisionIndex} className={invalidRowIds.includes(value.idCaseRevision) ? 'invalid-table-row' : ''}>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.revisionType}</span>
            <span>{value.additionalDescription}</span>
          </div>
        </td>
        <td>
          <span>{value.authorizedAuditor}</span>
        </td>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.revisionMark}</span>
            <span>{convertDateFromServer(value.revisionDate)}</span>
          </div>
        </td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canViewDocument && (
              <TooltipWrapper message={'Pregledaj dokument'}>
                <FontAwesomeIcon icon={'file'} className={'icon-table'} onClick={() => downloadFile(value)} />
              </TooltipWrapper>
            )}
            {!editRevisionDisabled && (
              <>
                {sidebarItemPair?.canView && (
                  <TooltipWrapper message={'Pregledaj reviziju'}>
                    <FontAwesomeIcon
                      icon={'eye'}
                      className={'icon-table'}
                      onClick={() => openMainProjectRevisionForm(value.idCaseRevision, true)}
                    />
                  </TooltipWrapper>
                )}
                {sidebarItemPair?.canEdit && (
                  <TooltipWrapper message={'Uredi'}>
                    <FontAwesomeIcon
                      icon={'pen-to-square'}
                      className={'icon-table'}
                      onClick={() => openMainProjectRevisionForm(value.idCaseRevision, false)}
                    />
                  </TooltipWrapper>
                )}
                {sidebarItemPair?.canDelete && (
                  <TooltipWrapper message={'Obriši'}>
                    <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idCaseRevision)} />
                  </TooltipWrapper>
                )}
              </>
            )}
          </div>
        </td>
      </tr>
    );
  };

  const downloadFile = (value: CaseRevisionViewModel) => {
    getCaseRevisionFile(value.idCaseRevision)
      .then(data => {
        if (data) {
          openFileInNewWindow(data.url)
        }
      })
      .catch(err => showToast(error, 'Dogodila se greška prilikom preuzimanja dokumenta.'));
  };

  return (
    <>
      <ViewTable
        initialPaginationColumn={'idCaseRevision'}
        initialSortDirection={'asc'}
        renderTableRow={renderTableRow}
        fetchDataQuery={fetchCaseRevisionsTableQuery}
        fetchDataProps={id}
        noDataMessage={'Nema dodanih revizija.'}
      >
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Vrsta revizije', 'Dodatni opis']} width={'260px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Ovlašteni revident']} width={'340px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Oznaka', 'Datum izrade']} width={'180px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'120px'} />
      </ViewTable>

      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje revizije</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} color={'secondary'} />
          <Button size={'lg'} label="Obriši" onClick={removeMainProjectRevision} color={'info'} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CaseRevisionTable;
